// Pixel Tracking Utility
export const trackPixel = (url, eventData = {}) => {
  const img = new Image(1, 1);
  const params = new URLSearchParams(eventData).toString();
  img.src = `${url}?${params}`;
};

export const trackEvent = (eventName, data = {}) => {
  const trackingUrl = process.env.REACT_APP_TRACKING_URL || 'https://your-tracking-server.com/pixel';
  trackPixel(trackingUrl, {
    event: eventName,
    timestamp: Date.now(),
    url: window.location.href,
    ...data
  });
};

export const trackPageView = () => {
  trackEvent('page_view', {
    path: window.location.pathname,
    referrer: document.referrer
  });
};
